<template>
	<div>
		<vs-row>
			<vs-col vs-type="flex" vs-w="3" class="p-2">
				<statistics-card-line icon="FilmIcon" icon-right :statistic="items.contents.all"
					statisticTitle="Contents" color="warning" />
			</vs-col>
			<vs-col vs-type="flex" vs-w="3" class="p-2">
				<statistics-card-line icon="MonitorIcon" icon-right :statistic="items.contents.series"
					statisticTitle="Series Count" />
			</vs-col>
			<vs-col vs-type="flex" vs-w="3" class="p-2">
				<statistics-card-line icon="FilmIcon" icon-right :statistic="items.contents.movies"
					statisticTitle="Movies Count" />
			</vs-col>
			<vs-col vs-type="flex" vs-w="3" class="p-2">
				<statistics-card-line icon="VideoIcon" icon-right :statistic="items.videos.all"
					statisticTitle="Videos Count" />
			</vs-col>
			<vs-col vs-type="flex" vs-w="3" class="p-2">
				<statistics-card-line icon="UsersIcon" icon-right :statistic="items.staff.all"
					statisticTitle="Staff Count" />
			</vs-col>
			<vs-col vs-type="flex" vs-w="3" class="p-2">
				<statistics-card-line icon="VideoIcon" icon-right :statistic="items.counts.reels"
					statisticTitle="Reels Count" />
			</vs-col>
			<vs-col vs-type="flex" vs-w="3" class="p-2">
				<statistics-card-line icon="ActivityIcon" icon-right :statistic="items.counts.stories"
					statisticTitle="Stories Count" />
			</vs-col>
			<vs-col vs-type="flex" vs-w="3" class="p-2">
				<statistics-card-line icon="HashIcon" icon-right :statistic="items.counts.genres"
					statisticTitle="Genres Count" />
			</vs-col>
			<vs-col vs-type="flex" vs-w="3" class="p-2">
				<statistics-card-line icon="UserIcon" icon-right :statistic="items.counts.users"
					statisticTitle="Users Count" />
			</vs-col>
			<vs-col vs-type="flex" vs-w="3" class="p-2">
				<statistics-card-line icon="PackageIcon" icon-right :statistic="items.counts.collections"
					statisticTitle="Collection Count" />
			</vs-col>
		</vs-row>
		<vs-row vs-w="12">



			<vs-col vs-type="flex" vs-w="4" class="p-2">
				<vx-card v-if="items.length !=0">
					<h3>Staff Statistics</h3>
					<vue-apex-charts type="donut" height="350" :options="radialBarChart.chartOptions"
						:series="radialBarChart.series"></vue-apex-charts>
				</vx-card>
			</vs-col>
			<vs-col vs-type="flex" vs-w="4" class="p-2">
				<vx-card v-if="items.length !=0">
					<h3>Contents Statistics</h3>
					<vue-apex-charts type="pie" height="400" width="400" :options="contents_chart.chartOptions"
						:series="contents_chart.series"></vue-apex-charts>
				</vx-card>
			</vs-col>
			<vs-col vs-type="flex" vs-w="12" class="p-2">
				<vx-card v-if="items.length !=0">
					<h3>Genres Statistics</h3>
					<vue-apex-charts type="bar" height="400" :options="genres_chart.chartOptions"
						:series="genres_chart.series"></vue-apex-charts>

				</vx-card>
			</vs-col>

		</vs-row>
	</div>

</template>
<script>
	import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
	import VueApexCharts from 'vue-apexcharts'
	export default {
		components: {
			StatisticsCardLine,
			VueApexCharts
		},
		data() {
			return {
				items: [],
				radialBarChart: [],
				contents_chart: [],
				genres_chart: [],

			}
		},
		created() {
			this.fetchstatistics()
		},
		methods: {
			fetchstatistics() {
				this.$vs.loading();
				this.axios.get(`${this.$apiUrl}/statistics`).then(res => {
					this.$vs.loading.close();
					this.items = res.data;
					this.radialBarChart.series = this.items.staff.series,
						this.radialBarChart.chartOptions = {
							colors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E', '#7367F0', '#28C76F',
								'#EA5455', '#FF9F43', '#1E1E1E', '#7367F0', '#28C76F', '#EA5455', '#FF9F43',
								'#1E1E1E'
							],
							plotOptions: {
								radialBar: {
									dataLabels: {
										name: {
											fontSize: '22px',
										},
										value: {
											fontSize: '16px',
										},
										total: {
											show: true,
											label: 'Total',
											formatter: function (w) {
												// By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
												return 249
											}
										}
									}
								}
							},
							labels: this.items.staff.labels,
						};
					this.contents_chart = {
						series: [this.items.contents.movies_avg, this.items.contents.series_avg],
						chartOptions: {
							labels: ['Movies', 'Series'],
							colors: ['#EA5455', '#FF9F43', '#1E1E1E', '#7367F0', '#28C76F', '#EA5455',
								'#FF9F43', '#1E1E1E'
							],

							responsive: [{
								breakpoint: 480,
								options: {
									chart: {
										width: 200
									},
									legend: {
										position: 'center'
									}
								}
							}]
						}
					};

					this.genres_chart = {
						series: this.items.genres.series,
						chartOptions: {
							colors: ['#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
							plotOptions: {
								bar: {
									horizontal: false,
									endingShape: 'rounded',
									columnWidth: '80%',
								},
							},
							dataLabels: {
								enabled: false
							},
							stroke: {
								show: true,
								width: 2,
								colors: ['transparent']
							},

							xaxis: {
								categories: this.items.genres.labels,
							},
							yaxis: {
								title: {
									text: ' (item)'
								}
							},
							fill: {
								opacity: 1

							},
							tooltip: {
								y: {
									formatter: function (val) {
										return "  " + val + " item"
									}
								}
							}
						}
					};
				})
			}
		},
	}
</script>